export enum FinancialSalaryDistribution {
  ByMile = 0,
  ByActiveConfiguredTruck = 1
}

export const FinancialSalaryDistributionMapping: Record<
  FinancialSalaryDistribution,
  string
> = {
  [FinancialSalaryDistribution.ByMile]: 'By Mile',
  [FinancialSalaryDistribution.ByActiveConfiguredTruck]:
    'By Truck'
};
